import styled from "styled-components";
import { PaddingLeftCol } from "@components/leftGrid";

export const DateInputWrapper = styled(PaddingLeftCol)`
  display: flex;
  flex-direction: row;
  gap: 8px;
  padding: 0 !important;
`;